import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useAuthenticationStore } from "@/store/authentication.store";
import { useFlag } from "@/composables/useFlags/useFlag";
import { identifyAppcuesUser } from "@/utils/appcues";

const ADMIN_ROLE = "admin";
const SUPER_ADMIN_ROLE = "super-admin";
const ADMIN_LEVELS = new Set(["msp", "customer"]);
const ORG_PATH_PATTERN = /^\/(msp|customer)\/[^/]+/;

type TourUser = { id?: string; role?: string; level?: string } | null;

export const useAppcuesBlockListFlagSync = (): void => {
  const authStore = useAuthenticationStore();
  const { isFeatureAvailable: isBlockListFlagOn } = useFlag(
    "BLOCK_LIST_MAIL_FLOW_LINK",
  );

  const user = computed(() => authStore.authUser as TourUser);
  const userId = computed(() => user.value?.id ?? null);
  const isEligibleRole = computed(
    () =>
      user.value?.role === SUPER_ADMIN_ROLE ||
      (user.value?.role === ADMIN_ROLE &&
        ADMIN_LEVELS.has(user.value?.level ?? "")),
  );
  const blockListEnabled = computed(
    () => isEligibleRole.value && isBlockListFlagOn.value,
  );
  const route = useRoute();
  const orgPath = computed(
    () => route?.path?.match(ORG_PATH_PATTERN)?.[0] ?? null,
  );

  watch(
    [userId, blockListEnabled, orgPath],
    ([id, enabled, path]) => {
      if (!id) return;
      identifyAppcuesUser(id, {
        blockListEnabled: enabled,
        ...(path ? { orgPath: path } : {}),
      });
    },
    { immediate: true },
  );
};
